function initActivoPageViewChart(showRightAxis = false) {
  const chartCanvas = document.getElementById("pageViewChart");
  if (!chartCanvas) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const ctx = chartCanvas.getContext("2d");
          const pageViewData = [
            57, 186, 281, 584, 613, 841, 1291, 1336, 1827, 2358, 2469, 2383,
          ];
          const labels = [
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
          ];

          const yAxesConfig = [
            {
              id: "y-axis-left",
              position: "left",
              ticks: {
                beginAtZero: true,
                max: 2500,
                callback(value) {
                  return `${value}万`;
                },
              },
            },
          ];

          // スマホ表示の場合は右側にもy軸を追加
          if (showRightAxis) {
            yAxesConfig.push({
              id: "y-axis-right",
              position: "right",
              ticks: {
                beginAtZero: true,
                max: 2500,
                callback(value) {
                  return `${value}万`;
                },
              },
              gridLines: {
                display: false,
                drawBorder: false,
              },
            });
          }

          const datasetConfig = {
            label: "累計ページビュー数（万PV）",
            data: pageViewData,
            backgroundColor: "#60c31d",
            borderColor: "#60c31d",
            borderWidth: 1,
          };

          if (showRightAxis) {
            datasetConfig.yAxisID = "y-axis-left";
          }

          const _chart = new Chart(ctx, {
            type: "bar",
            data: {
              labels,
              datasets: [datasetConfig],
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              animation: {
                duration: 2000,
                easing: "easeOutCubic",
              },
              scales: {
                yAxes: yAxesConfig,
                xAxes: [
                  {
                    ticks: {
                      fontSize: 14,
                    },
                  },
                ],
              },
              legend: {
                display: false,
              },
              tooltips: {
                callbacks: {
                  label(tooltipItem) {
                    return `${tooltipItem.yLabel.toLocaleString()}万PV`;
                  },
                },
              },
            },
          });

          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.3,
    }
  );

  observer.observe(chartCanvas);
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default initActivoPageViewChart;